import React, { PropTypes, Component } from 'react';
import { MenuItem, IconButton, DropDownMenu, Checkbox, RadioButton, RadioButtonGroup, Table, TableRow, TableRowColumn, TableHeader, TableBody, TableHeaderColumn } from 'material-ui';
import { teams, availableAccess, permissionTypes } from '../teamPermissionOptions';
import R from 'ramda';
import Select from 'react-select';

const isNilOrEmpty = R.either(R.isEmpty, R.isNil);

class MultiLocPermissions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allLocsAccess: false,
      allLocsSameTeamAndLocs: props.allLocsSameTeamAndLocs,
    };
  }
  componentWillReceiveProps(nextProps) {
    if (R.isNil(this.state.allLocsSameTeamAndLocs) &&
      !R.isNil(nextProps.allLocsSameTeamAndLocs)) {
      this.setState({ allLocsSameTeamAndLocs: nextProps.allLocsSameTeamAndLocs });
    }
  }
  render() {
    const {
      userName,
      locations,
      onLocSelection,
      selectedLocs,
      onCorporateLocCheck,
      showCorporateProfileRadioButtons,
      isAccom,
      corporateProfileAccess,
      isSingleLoc,
    } = this.props;
    const { allLocsSameTeamAndLocs, allLocsAccess } = this.state;
    const options = (() => {
      const locList = locations.map(loc => ({
        value: loc._id,
        label: loc.property_name,
        locId: loc._id,
        disabled: loc.disabled,
      }));
      return R.prepend({ value: 'allLocs', label: `All ${isAccom ? 'Properties' : 'Locations'}` }, locList);
    })();
    const removeAllLocsField = R.without(
      [{ value: 'allLocs', label: `All ${isAccom ? 'Properties' : 'Locations'}` }],
      options,
      );
    const allLocsSelected = selectedLocs.length === locations.length;
    const showAllTextOrNumOrLocs = allLocsSelected ? 'all' : `${selectedLocs.length}`;
    const teamCheckboxes = ({ allLocsSameTeam, locObj = {}, outerDivStyle }) => {
      const findLoc = allLocsSameTeam ? selectedLocs[0] : selectedLocs.filter(loc => loc.locId === locObj.locId)[0];
      return (
        <div style={R.merge({ display: 'flex', flexWrap: 'wrap', flexDirection: 'column' }, outerDivStyle)}>
          {
            teams.map((team, i) => (
              <div key={i} style={{ marginTop: i === R.dec(teams.length) ? '15px' : '' }}>
                <Checkbox
                  label={team}
                  style={{ display: 'flex', width: '50%' }}
                  checked={R.contains(team, findLoc.teams)}
                  disabled={locObj.disabled}
                  onCheck={() => {
                    if (allLocsSameTeam) {
                      onLocSelection(selectedLocs.map(loc => R.merge(loc, { teams: R.contains(team, loc.teams) ? R.without([team], loc.teams) : R.append(team, loc.teams) })));
                    } else {
                      const updateTeams = R.contains(team, findLoc.teams) ? R.without([team], findLoc.teams) : R.append(team, findLoc.teams);
                      const updateLoc = R.merge(findLoc, { teams: updateTeams });
                      onLocSelection(selectedLocs.map(loc => {
                        if (loc.locId === locObj.locId) return updateLoc;
                        return loc;
                      }));
                    }
                  }}
                />
              </div>
            ))
          }
        </div>
      );
    };

    const accessDropdown = ({ allLocsSameAccess, locObj = {}, borderTopColor, outerDivStyle, outerTableStyle }) => (
      <div style={R.merge(outerDivStyle, { marginBottom: '15px', display: 'flex', width: '100%' })}>
        {
          permissionTypes.map((type, k) => {
            const findLoc = allLocsSameAccess ? selectedLocs[0] : selectedLocs.filter(lc => lc.locId === locObj.locId)[0];
            const hideLastBorder = k === R.dec(permissionTypes.length) ? 'transparent' : '#d8d8d8';
            return (
              <div key={k} style={R.merge({ display: 'flex', alignItems: 'center' }, outerTableStyle)}>
                <div style={R.merge(outerTableStyle, { width: '45%' })}>
                  <span className={k === R.dec(permissionTypes.length) ? 'hint--top' : 'hint--bottom'} aria-label={type.hintTextMultiLoc}>{type.label}:</span>
                </div>
                <DropDownMenu
                  value={(() => {
                    if (findLoc[type.value]) {
                      if (findLoc[type.value].indexOf('write') > -1) return 'Read and Write';
                      if (findLoc[type.value].indexOf('read') > -1) return 'Read Only';
                    }
                    return 'No Access';
                  })()}
                  underlineStyle={{ borderTopColor: borderTopColor ? '#d8d8d8' : hideLastBorder }}
                  labelStyle={{ paddingRight: 0 }}
                  style={{ display: 'flex', marginTop: '-10px', width: '55%' }}
                >
                  {
                    availableAccess.map((access, i) => (
                      <MenuItem
                        key={i}
                        value={access.label}
                        primaryText={access.label}
                        label={access.label}
                        disabled={locObj.disabled}
                        onTouchTap={() => {
                          onLocSelection(selectedLocs.map(location => {
                            if (allLocsSameAccess || location.locId === locObj.locId) {
                              return R.merge(location, {
                                profile: type.value === 'profile' ? access.value : location.profile,
                                contracting: type.value === 'contracting' ? access.value : location.contracting,
                                admin: type.value === 'admin' ? access.value : location.admin,
                              });
                            }
                            return location;
                          }));
                        }}
                      />
                    ))
                  }
                </DropDownMenu>
              </div>
            );
          })
        }
      </div>
    );

    return (
      <div>
        {
          showCorporateProfileRadioButtons &&
            <div style={{ marginTop: '15px', display: 'inline-block', width: '100%' }}>
              <div style={{ float: 'left', width: '65%' }}>
                <span className="hint--bottom" aria-label={`Gives the user access to edit the corporate profile and create new ${isAccom ? 'properties' : 'locations'}.`}>
                  Would you like <b>{userName}</b> to have access to edit corporate profile?
                </span>
              </div>
              <div style={{ float: 'left', width: '35%', display: 'inline-block' }}>
                <RadioButtonGroup
                  name="corporateProfile"
                  defaultSelected={corporateProfileAccess ? 'yes' : 'no'}
                  onChange={onCorporateLocCheck}
                  style={{ display: 'inline-block', width: '100%' }}
                >
                  <RadioButton value="no" label="No" style={{ width: '50%', display: 'inline-block' }} />
                  <RadioButton value="yes" label="Yes" style={{ width: '50%', display: 'inline-block' }} />
                </RadioButtonGroup>
              </div>
            </div>
        }
        {
          !isSingleLoc &&
            <div style={{ margin: '20px 0 30px 0' }}>
              <div style={{ marginTop: '10px' }}>
                Select which {isAccom ? 'property' : 'location'}(s) <b>{userName}</b> has access to:
                {
                  allLocsSelected ?
                    <div style={{ display: 'inline-block', marginLeft: '5px' }}>
                      All {locations.length} {isAccom ? 'Properties' : 'Locations'}
                      <IconButton
                        iconClassName="tc-icon-close"
                        iconStyle={{ color: 'rgb(255, 64, 129)', padding: 0, fontSize: '14px', marginLeft: '-10px' }}
                        onTouchTap={() => {
                          this.setState({ allLocsAccess: false, allLocsSameTeamAndLocs: null });
                          onLocSelection([]);
                        }}
                      />
                    </div> :
                    <Select
                      multi
                      name={"selectedLocs"}
                      onChange={(selections) => {
                        const isAllLocsSelected = R.contains('allLocs', R.pluck('value')(selections));
                        this.setState({ allLocsAccess: isAllLocsSelected });
                        const newSelectedLocs = isAllLocsSelected ? removeAllLocsField : selections;
                        const processedLocsSelected = [
                          // filter out removed ones
                          ...selectedLocs.filter(obj =>
                            newSelectedLocs.some(newSelected => newSelected.locId === obj.locId)),
                          // add new ones
                          ...newSelectedLocs.filter(newSelected =>
                            selectedLocs.every(loc => loc.locId !== newSelected.locId))
                            .map(loc => ({
                              locId: loc.locId,
                              property_name: loc.label,
                              teams: [],
                              contracting: [],
                              profile: [],
                              admin: [],
                              value: loc.value,
                              label: loc.label,
                            })),
                        ];
                        onLocSelection(processedLocsSelected);
                      }}
                      placeholder={`Search for a ${isAccom ? 'property' : 'location'}...`}
                      options={allLocsAccess
                        ? R.without(selectedLocs, removeAllLocsField)
                        : R.without(selectedLocs, options)}
                      value={selectedLocs}
                      scrollMenuIntoView={false}
                    />
                }
              </div>
              {
                !isNilOrEmpty(selectedLocs) && selectedLocs.length > 1 &&
                  <div style={{ marginTop: allLocsAccess ? '10px' : '15px' }}>
                    Do you want {userName} to be assigned to the same team(s) and have the same access levels for all {showAllTextOrNumOrLocs} {isAccom ? 'properties' : 'locations'}?
                    <RadioButtonGroup
                      name="allLocsSameTeamAndLocs"
                      valueSelected={allLocsSameTeamAndLocs}
                      onChange={(_, selected) => {
                        this.setState({ allLocsSameTeamAndLocs: selected });
                        onLocSelection(selectedLocs.map(loc => R.merge(loc, { teams: [], profile: [], contracting: [], admin: [] })));
                      }}
                    >
                      <RadioButton value label={`Yes, ${userName} should have the same team(s) and access across all ${isAccom ? 'properties' : 'locations'}.`} />
                      <RadioButton value={false} label={`No, I want to assign the teams and access levels for each ${isAccom ? 'property' : 'location'}.`} />
                    </RadioButtonGroup>
                </div>
              }
            </div>
        }
        {
          (!isNilOrEmpty(allLocsSameTeamAndLocs) || selectedLocs.length === 1) &&
            <div>
              {
                !allLocsSameTeamAndLocs ?
                  <div style={{ marginTop: '-10px' }}>
                    <Table>
                      <TableHeader adjustForCheckbox={false} displaySelectAll={false}>
                        <TableRow>
                          <TableHeaderColumn style={{ width: '30%' }}>Location</TableHeaderColumn>
                          <TableHeaderColumn style={{ width: '30%' }}>Team(s)</TableHeaderColumn>
                          <TableHeaderColumn>Access</TableHeaderColumn>
                        </TableRow>
                      </TableHeader>
                      <TableBody displayRowCheckbox={false}>
                        {
                          selectedLocs.map((loc, i) => {
                            const locObj = { locId: loc.locId, disabled: loc.disabled };
                            return (
                              <TableRow key={loc.locId} selectable={false}>
                                <TableRowColumn style={{ width: '30%' }}>{loc.label}</TableRowColumn>
                                <TableRowColumn style={{ width: '25%' }}>{teamCheckboxes({ locObj, outerDivStyle: { marginTop: '-15px' } })}</TableRowColumn>
                                <TableRowColumn style={{ overflow: 'visible' }}>
                                  {accessDropdown({ locObj, borderTopColor: false, outerDivStyle: { flexWrap: 'wrap' }, outerTableStyle: { width: '100%' } })}
                                </TableRowColumn>
                              </TableRow>
                            );
                          })
                        }
                      </TableBody>
                    </Table>
                  </div> :
                  <div>
                    <div>
                      Would you like to add {userName} to a team? Teams can be used to manage user permissions for different departments at your company.
                      {teamCheckboxes({ allLocsSameTeam: true, outerDivStyle: { marginTop: '5px' } })}
                    </div>
                    <div style={{ marginTop: '30px', display: 'flex', flexWrap: 'wrap', flexDirection: 'row' }}>
                      Set what access level {userName} should have:
                      {accessDropdown({ allLocsSameAccess: true, borderTopColor: true, outerDivStyle: { marginTop: '5px', flexDirection: 'column' }, outerTableStyle: { width: '50%' } })}
                    </div>
                  </div>
              }
            </div>
        }
      </div>
    );
  }
}

MultiLocPermissions.propTypes = {
  teams: PropTypes.array,
  userName: PropTypes.string,
  locations: PropTypes.array,
  onLocSelection: PropTypes.func,
  selectedLocs: PropTypes.array,
  onCorporateLocCheck: PropTypes.func,
  showCorporateProfileRadioButtons: PropTypes.bool,
  onlyHasAccessToOneLoc: PropTypes.bool,
  isAccom: PropTypes.bool,
  allLocsSameTeamAndLocs: PropTypes.bool,
  corporateProfileAccess: PropTypes.bool,
  isSingleLoc: PropTypes.bool,
};

export default MultiLocPermissions;



// WEBPACK FOOTER //
// ./src/app/components/settings/userManagement/newUser/multiLocPermissions.jsx